<script lang="ts" setup>
import { MessageCircleOff } from 'lucide-vue-next';

import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import EmptyState from '@sigma/ui/EmptyState.vue';

import * as l from './ChatNotFound.loc.js';

const t = useTranslate();
</script>

<template>
  <div
    tid="chat-not-found"
    :class="css.container"
  >
    <EmptyState :icon="MessageCircleOff">
      <template #title>
        {{ t(l.title) }}
      </template>

      <template #subtitle>
        {{ t(l.subtitle) }}
      </template>
    </EmptyState>
  </div>
</template>

<style lang="scss" module="css">
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  padding: $spacing-32;
}
</style>
